import { render, staticRenderFns } from "./DataViewer.vue?vue&type=template&id=0a938599&scoped=true&"
import script from "./DataViewer.vue?vue&type=script&lang=js&"
export * from "./DataViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a938599",
  null
  
)

export default component.exports